import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment';
import { CommonService } from '../../common-service';
import { BatchExtracaoDadosLookupResponse } from '../../responses/batch-extracao-dados/batch-extracao-dados-lookup.response';

@Injectable({
  providedIn: 'root',
})
export class BatchExtracaoDadosLookupService extends CommonService {
  // Ajuste a URL base conforme a configuração do seu environment.ts
  private readonly apiUrl: string = environment.urlApiBatchExtracaoDados + 'Lookup';

  constructor(
    private httpClient: HttpClient
  ) {
    super();
  }

  /**
   * Obtém as listas de lookup (TipoExtracao, TipoRecorrencia, etc).
   * Corresponde a: [HttpGet] /Lookup
   */
  public get(): Observable<BatchExtracaoDadosLookupResponse> {
    return this.httpClient
      .get<BatchExtracaoDadosLookupResponse>(this.apiUrl, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }
}